<template>
  <div class="pl30 pr30 pdiv">
    <baidu-map id="baidumap" :class="{amap: (article ? true : false), map}" ak="KbGbuk~~~BWmEjf"
                :center="map.center"
                :zoom="map.zoom"
                :scroll-wheel-zoom="map.scroll"
             >
        <!-- 缩放控件，所有地图的组件都要写在 baidu-map组件内-->
      <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
      <bm-marker :position="{lng: 121.405764, lat: 28.659357}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
      </bm-marker>
    </baidu-map>
  </div>
</template>
<script>
  import BaiduMap from 'vue-baidu-map/components/map/Map.vue'//用什么引入什么就好，路径在下载的github项目中可以看到
  import BmNavigation from 'vue-baidu-map/components/controls/Navigation.vue'//引入缩放控件
  import BmMarker from 'vue-baidu-map/components/overlays/marker.vue'//引入缩放控件
  import BmLabel from 'vue-baidu-map/components/overlays/label.vue'
  export default {
    name: "EMap",
    components: {
      BaiduMap,
      BmNavigation,
      BmMarker,
      BmLabel,
    },
    props: ['article', 'address'],
    data() {
      console.log(this.article)
      return {
          map: {
            center: {lng: 121.405764, lat: 28.659357},//'襄阳市',地图的中心点坐标
            zoom: 16,//1-18，数值越大离地面越近，地图实际面积越小
            scroll: true //支持滚动鼠标缩放
          },
      }
    },
  }
</script>

<style>
  .pdiv{
    margin-top: -90px;
    padding: 0 5px 80px 35px;
  }
  .map{
    width: 100%;
    height: 400px;
  }
  .map.amap{
    width: 100%;
    height: 500px;
  }

</style>



// WEBPACK FOOTER //
// src/components/cedu/EMap.vue